import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserHotelAuroraGame from 'src/games/HotelAuroraGame/Main';

interface HotelAuroraGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class HotelAuroraGame extends React.Component<HotelAuroraGameProps> {
    constructor(props: HotelAuroraGameProps) {
        super(props);
        bindAllOfThis(this, HotelAuroraGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserHotelAuroraGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default HotelAuroraGame;



// WEBPACK FOOTER //
// ./src/pages/game/HotelAuroraGame.tsx